import { EGroupedItemsType } from '~/src/services/properties';

export const sliderImageConfig = {
    label: {
        name: 'label',
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            content: {
                name: 'content',
                order: 1,
                label: 'Адрес изображения:',
                type: EGroupedItemsType.File,
            },
            webp: {
                name: 'webp',
                type: EGroupedItemsType.Hidden,
            },
            alt: {
                name: 'alt',
                order: 2,
                label: 'Alt-текст:',
                type: EGroupedItemsType.String,
            },
            customize: {
                name: 'customize',
                label: 'Настройки изображения',
                order: 4,
                items: {
                    width: {
                        name: 'width',
                        label: 'Ширина:',
                        type: EGroupedItemsType.String,
                    },
                    height: {
                        name: 'height',
                        label: 'Высота:',
                        type: EGroupedItemsType.String,
                    },
                },
            },
            removeElement: {
                name: 'removeElement',
                label: 'Удалить изображение',
                type: EGroupedItemsType.ButtonRemove,
                order: 2,
            },
        },
    },
};
